import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, name: string) =>
  axios.delete(
    `${process.env.REACT_APP_API_HOST}/admin/upload?name=${name}`,
    config(token)
  );
